import styled from 'styled-components'

export const PostReaction = styled.span`
  position: static;
  bottom: 60px;
  animation-name: scale-in;
  animation-duration: 0.15s;
  animation-timing-function: cubic-bezier(0.2, 0, 0.13, 1.5);
`
